// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.two-col[data-v-6f7b611a]{display:grid;grid-template-columns:1fr 1fr}`, "",{"version":3,"sources":["webpack://./src/components/CreditCustomerProfile/Reminders/styles.scoped.scss"],"names":[],"mappings":"AAAA,0BAA0B,YAAY,CAAC,6BAA6B","sourcesContent":[".two-col[data-v-6f7b611a]{display:grid;grid-template-columns:1fr 1fr}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
